import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, hasOne, references } from '@apexdesigner/schema-tools';

export const activityAssignment = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z.string().nullable().optional().describe('Name'),

    from: z.string().nullable().optional().presentAs('date').describe('From'),

    to: z.string().nullable().optional().presentAs('date').describe('To'),

    status: z.string().nullable().optional().describe('Status'),

    termTutorId: z.number().hidden().describe('Foreign key to TermTutor'),

    slotId: z.number().presentAs('reference').describe('Foreign key to Slot'),

    replacesId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to ActivityAssignment'),

    termTutor: belongsTo('TermTutor'),

    slot: references('Slot'),

    replaces: references('ActivityAssignment'),

    replacedBy: hasOne('ActivityAssignment', 'replacesId'),
  })
  .describe(
    'Pairs a term tutor with a slot and an activity, supporting propose/replace workflows.',
  )
  .as('ActivityAssignment');

export { activityAssignment as activityAssignmentSchema };
